export const domain = typeof window === "undefined" ? "" : baseDomain(window.location.host);
function baseDomain(host) {
    return host.split(".").slice(-2).join(".");
}
//# sourceMappingURL=domain.js.map